module.exports = __webpack_public_path__ + "static/media/reciclabc_logo_black.a81d61aa.svg";